import React, { useState } from 'react';
import { KontraTask } from '../types';
import { StatusBadge } from '../components/StatusBadge';
import { PriorityBadge } from '../components/PriorityBadge';
import { SummaryCard } from '../components/SummaryCard';
import { ShieldAlertIcon, SearchIcon, PlusIcon, ActivityIcon, CheckCircleIcon, ClockIcon, AlertTriangleIcon, CrosshairIcon } from 'lucide-react';
interface KontraPageProps {
  tasks: KontraTask[];
}
export function KontraPage({
  tasks
}: KontraPageProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('Semua Status');
  const [priorityFilter, setPriorityFilter] = useState('Semua Prioritas');
  const filteredTasks = tasks.filter(task => {
    const matchSearch = task.title.toLowerCase().includes(searchTerm.toLowerCase()) || task.code.toLowerCase().includes(searchTerm.toLowerCase()) || task.targetUrl.toLowerCase().includes(searchTerm.toLowerCase());
    const matchStatus = statusFilter === 'Semua Status' || task.status === statusFilter;
    const matchPriority = priorityFilter === 'Semua Prioritas' || task.priority === priorityFilter;
    return matchSearch && matchStatus && matchPriority;
  });
  // Stats
  const activeCount = tasks.filter(t => t.status === 'Berjalan').length;
  const plannedCount = tasks.filter(t => t.status === 'Direncanakan').length;
  const completedCount = tasks.filter(t => t.status === 'Selesai').length;
  const criticalCount = tasks.filter(t => t.threatLevel === 'Kritis').length;
  const handleAdd = () => alert('Fitur tambah tugas KONTRA akan tersedia pada versi berikutnya.');
  const handleView = (id: string) => alert(`Membuka detail tugas KONTRA: ${id}`);
  return <div className="space-y-6 flex flex-col h-full" data-id="element-642">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-643">
        <h2 className="text-2xl font-bold text-[#E2E8F0] uppercase tracking-wide flex items-center" data-id="element-644">
          <ShieldAlertIcon className="w-6 h-6 mr-3 text-[#FF3B3B]" data-id="element-645" />
          OPERASI KONTRA-NARASI (KONTRA)
        </h2>
        <button onClick={handleAdd} className="flex items-center px-4 py-2 bg-[#FF3B3B] text-[#0B0F1A] rounded hover:bg-[#FF3B3B]/90 transition-colors shadow-sm font-bold text-sm uppercase glow-red" data-id="element-646">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-647" />
          TAMBAH TUGAS
        </button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-648">
        <SummaryCard title="Tugas Berjalan" value={activeCount} icon={<ActivityIcon className="w-6 h-6" data-id="element-650" />} iconBgColor="bg-[#00D4FF]/10" iconColor="text-[#00D4FF]" borderColor="border-t-[#00D4FF]" data-id="element-649" />
        <SummaryCard title="Direncanakan" value={plannedCount} icon={<ClockIcon className="w-6 h-6" data-id="element-652" />} iconBgColor="bg-[#A855F7]/10" iconColor="text-[#A855F7]" borderColor="border-t-[#A855F7]" data-id="element-651" />
        <SummaryCard title="Ancaman Kritis" value={criticalCount} icon={<AlertTriangleIcon className="w-6 h-6" data-id="element-654" />} iconBgColor="bg-[#FF3B3B]/10" iconColor="text-[#FF3B3B]" borderColor="border-t-[#FF3B3B]" data-id="element-653" />
        <SummaryCard title="Tugas Selesai" value={completedCount} icon={<CheckCircleIcon className="w-6 h-6" data-id="element-656" />} iconBgColor="bg-[#00FF88]/10" iconColor="text-[#00FF88]" borderColor="border-t-[#00FF88]" data-id="element-655" />
      </div>

      {/* Filters */}
      <div className="bg-[#111827] p-4 rounded shadow-sm border border-[#1E3A5F] flex flex-wrap gap-4 items-center" data-id="element-657">
        <div className="relative flex-1 min-w-[200px]" data-id="element-658">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-659">
            <SearchIcon className="h-4 w-4 text-[#94A3B8]" data-id="element-660" />
          </div>
          <input type="text" placeholder="Cari kode, judul, atau URL target..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-[#1E3A5F] rounded text-sm focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0] placeholder-[#475569]" data-id="element-661" />
        </div>

        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="border border-[#1E3A5F] rounded text-sm py-2 pl-3 pr-8 focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0]" data-id="element-662">
          <option value="Semua Status" data-id="element-663">Semua Status</option>
          <option value="Draft" data-id="element-664">Draft</option>
          <option value="Direncanakan" data-id="element-665">Direncanakan</option>
          <option value="Berjalan" data-id="element-666">Berjalan</option>
          <option value="Selesai" data-id="element-667">Selesai</option>
          <option value="Dibatalkan" data-id="element-668">Dibatalkan</option>
        </select>

        <select value={priorityFilter} onChange={e => setPriorityFilter(e.target.value)} className="border border-[#1E3A5F] rounded text-sm py-2 pl-3 pr-8 focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0]" data-id="element-669">
          <option value="Semua Prioritas" data-id="element-670">Semua Prioritas</option>
          <option value="Rendah" data-id="element-671">Rendah</option>
          <option value="Sedang" data-id="element-672">Sedang</option>
          <option value="Tinggi" data-id="element-673">Tinggi</option>
          <option value="Sangat Tinggi" data-id="element-674">Sangat Tinggi</option>
        </select>
      </div>

      {/* Task List */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-id="element-675">
        {filteredTasks.length > 0 ? filteredTasks.map(task => <div key={task.id} className="bg-[#111827] border border-[#1E3A5F] rounded-lg p-5 hover:border-[#FF3B3B]/50 transition-colors shadow-lg flex flex-col group cursor-pointer relative overflow-hidden" onClick={() => handleView(task.id)} data-id="element-676">
              {task.threatLevel === 'Kritis' && <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden" data-id="element-677">
                  <div className="absolute top-2 -right-6 bg-[#FF3B3B] text-[#0B0F1A] text-[10px] font-bold uppercase py-1 px-8 transform rotate-45 shadow-md" data-id="element-678">
                    KRITIS
                  </div>
                </div>}

              <div className="flex justify-between items-start mb-3" data-id="element-679">
                <span className="text-xs font-mono text-[#FF3B3B] bg-[#FF3B3B]/10 px-2 py-1 rounded" data-id="element-680">
                  {task.code}
                </span>
                <StatusBadge status={task.status as any} data-id="element-681" />
              </div>
              <h3 className="text-lg font-bold text-[#E2E8F0] mb-2 line-clamp-2 group-hover:text-[#FF3B3B] transition-colors pr-6" data-id="element-682">
                {task.title}
              </h3>
              <p className="text-sm text-[#94A3B8] mb-4 line-clamp-2 flex-1" data-id="element-683">
                {task.description}
              </p>

              <div className="space-y-2 mb-4 bg-[#0B0F1A] p-3 rounded border border-[#1E3A5F]/50" data-id="element-684">
                <div className="flex justify-between text-xs" data-id="element-685">
                  <span className="text-[#64748B]" data-id="element-686">Aksi:</span>
                  <span className="text-[#E2E8F0] font-bold" data-id="element-687">
                    {task.actionType}
                  </span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-688">
                  <span className="text-[#64748B]" data-id="element-689">Platform:</span>
                  <span className="text-[#E2E8F0] font-medium" data-id="element-690">
                    {task.targetPlatform}
                  </span>
                </div>
                <div className="flex flex-col text-xs mt-1 pt-1 border-t border-[#1E3A5F]/30" data-id="element-691">
                  <span className="text-[#64748B] mb-1" data-id="element-692">Target URL:</span>
                  <span className="text-[#00D4FF] font-mono truncate hover:underline" onClick={e => e.stopPropagation()} data-id="element-693">
                    {task.targetUrl}
                  </span>
                </div>
              </div>

              <div className="pt-4 border-t border-[#1E3A5F] flex justify-between items-center mt-auto" data-id="element-694">
                <PriorityBadge priority={task.priority} data-id="element-695" />
                <div className="text-xs text-[#94A3B8] flex items-center" data-id="element-696">
                  <CrosshairIcon className="w-3 h-3 mr-1 text-[#FF3B3B]" data-id="element-697" />
                  {task.personInCharge}
                </div>
              </div>
            </div>) : <div className="col-span-full py-12 text-center bg-[#111827] border border-[#1E3A5F] rounded" data-id="element-698">
            <ShieldAlertIcon className="w-12 h-12 text-[#1E3A5F] mx-auto mb-3" data-id="element-699" />
            <p className="text-[#94A3B8]" data-id="element-700">
              Tidak ada tugas KONTRA yang ditemukan.
            </p>
          </div>}
      </div>
    </div>;
}